import styled from '@emotion/styled';

import { LayoutWrapper } from '@/components/layout/LayoutWrapper';
import CornerFlare from '@/public/images/corner-flare.svg';
import CornerSquiggle from '@/public/images/corner-squiggle.svg';

import type { ReactElement } from 'react';

export interface StandoutContainerProps {
  children: ReactElement;
  variant?: 'employers' | 'individuals';
}

const StandoutContainer = ({ children, variant }: StandoutContainerProps) => {
  let cornerDecoration;
  if (variant === 'employers') cornerDecoration = <CornerFlare />;
  if (variant === 'individuals') cornerDecoration = <CornerSquiggle />;

  return (
    <LayoutWrapper padding="0">
      {children}
      <CornerDecorationContainer variant={variant}>
        {cornerDecoration}
      </CornerDecorationContainer>
    </LayoutWrapper>
  );
};

const CornerDecorationContainer = styled.div<{
  variant?: 'employers' | 'individuals';
}>`
  position: relative;
  > svg {
    position: absolute;
    ${({ variant }) =>
      variant === 'employers' && `bottom: -32px; right: -37px;`}
    ${({ variant }) =>
      variant === 'individuals' && `bottom: -40px; right: -26px;`}
  }
`;

export { StandoutContainer };
